import { useEffect,  useCallback, useState } from 'react'
import { useEsri } from '../../esriHooks'
import { useSelector } from 'react-redux'

import { getView } from '../selectors'

export const useLocate = (mapId) => {
  const [ready, { Locate }] = useEsri(['esri/widgets/Locate'])
  
  const view = useSelector(getView(mapId))
  const [locate, setLocate] = useState(null)

  useEffect(() => {
    if (ready && Locate && view) {
      const newLocator = new Locate({ view: view })
      setLocate(newLocator)
    }
  }, [view, Locate, ready])

  const onClick = useCallback(() => locate && locate.locate(), [locate])

  return onClick
}